import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const StyledJumbotron = styled.div`
  ${({ backgroundColor }) => css`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background-color: ${backgroundColor};
    padding: 32px 0;
  `};
`;

export const PaddingContainer = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  }
`;

export const JumbotronMensagens = styled(PaddingContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const DataTableWrapper = styled.div`
  padding: 24px 0 32px 0;
`;

export const WrapperForm = styled.section`
  display: grid;
  gap: 16px;
  margin: 30px 0;
`;

export const SectionReponse = styled.section`
  grid-template-columns: 3fr 1fr;
  display: grid;
  gap: 16px;

  label {
    margin: 7px 0 0 auto;
  }
`;

export const SectionButton = styled.section`
  grid-template-columns: repeat(3, 1fr);
  display: flex !important;
  gap: 32px;
  margin-top: 10px;
  margin-bottom: 32px;
`;

export const WrapperLabel = styled.div`
  display: grid;
  gap: 2px;
`;

export const WrapperList = styled.ul`
  display: grid;
  flex-direction: column;
  grid-template-columns: repeat(1, 1fr);
  gap: 8px;
  overflow: auto;
`;

export const WrapperItem = styled.li`
  align-items: center;
  justify-content: space-between;
`;

export const WrapperBtn = styled.div`
  display: flex;
  align-items: center;
`;

export const WrapperHeader = styled.div`
  .BaSe--button {
    margin-top: 24px;
    width: 100%;
  }
  .BaSe--paragraph {
    margin-left: 10px;
  }
`;

export const WrapperCredential = styled.div`
  padding: 4px 0;
  display: grid;
  gap: 28px;
`;

export const PopoverCard = styled.div`
  .BaSe--Popover-card {
    margin-left: 400px;
    margin-top: ${(props) => props.pos};
    padding: 10px 32px 10px 16px;
  }
`;

export const Flexed = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  align-self: center;
  height: 100%;
`;

export const ButtonsGrid = styled.div`
  display: flex;
  gap: 32px;
  justify-content: flex-end;
`;

export const BackWrapper = styled.div`
  display: flex;
  gap: 8px;

  .BaSe--paragraph {
    cursor: pointer;
    :hover {
      color: ${BaSeTheme.colors.institucionais.azulSebrae75};
    }
  }
  .i {
    color: ${BaSeTheme.colors.institucionais.azulSebrae75};
  }
`;

export const Return = styled.i`
  border: solid ${BaSeTheme.colors.institucionais.azulSebrae36};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  margin: 9px 4px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
`;
